import { render, staticRenderFns } from "./candidate-ranking-component.vue?vue&type=template&id=de96c812&scoped=true"
import script from "./candidate-ranking-component.ts?vue&type=script&lang=ts&external"
export * from "./candidate-ranking-component.ts?vue&type=script&lang=ts&external"
import style0 from "./candidate-ranking-component.scss?vue&type=style&index=0&id=de96c812&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de96c812",
  null
  
)

export default component.exports